import React, { useEffect, useState } from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Trade from "@/pages/Trade";
import Strategy from "@/pages/Strategy";
import Backtest from "@/pages/Backtest";
import Portfolio from "@/pages/Portfolio";
import Settings from "@/pages/Settings";
import { api } from "@/lib/api";

function AppShell({ children }) {
  const [mode, setMode] = useState({ mode: "paper", demo: false });
  useEffect(() => {
    api.get("/mode").then((r) => setMode(r.data)).catch(() => {});
  }, []);
  return (
    <Layout mode={mode.mode} demo={mode.demo}>{children}</Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="bottom-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/" element={<ProtectedRoute><AppShell><Dashboard /></AppShell></ProtectedRoute>} />
          <Route path="/trade" element={<ProtectedRoute><AppShell><Trade /></AppShell></ProtectedRoute>} />
          <Route path="/strategy" element={<ProtectedRoute><AppShell><Strategy /></AppShell></ProtectedRoute>} />
          <Route path="/backtest" element={<ProtectedRoute><AppShell><Backtest /></AppShell></ProtectedRoute>} />
          <Route path="/portfolio" element={<ProtectedRoute><AppShell><Portfolio /></AppShell></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><AppShell><Settings /></AppShell></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
